import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CheckCircleOutlinedIcon from '@mui/icons-material/CheckCircleOutlined';
import { Box, IconButton, Stack } from '@mui/material';
import { useEffect, useState } from 'react';
import InlineEditableField from '../common/inline.editable.field';
import StudentName from '../student/student.name';
import { attendanceApi } from './attendance.queries';

export default function AttendanceButton(props) {
	const { student, date, attendance } = props;
	const [status, setStatus] = useState(attendance?.status);

	const useSave = attendanceApi.useSave();
	const useSet = attendanceApi.useSet();

	useEffect(() => {
		setStatus(attendance?.status);
	}, [student, date, attendance]);

	if (!student?.id || !date) {
		return;
	}

	const save = async () => {
		let newStatus = status == 'Present' ? 'Absent' : 'Present';
		const result = await useSet.mutateAsync({ studentId: student.id, date, status: newStatus });
		setStatus(newStatus);
	}

	const iconSx = { fontSize: 40 };

	return (
		<Box>
			<Stack key={student.id} alignItems="center">
				<IconButton onClick={save}>
					{!status && <CheckCircleOutlinedIcon sx={iconSx} className="hover-subtle" color="muted" title="Toggle the student's attendance" />}
					{status == 'Present' && <CheckCircleIcon sx={iconSx} color="success" title="Present (tap to toggle)" />}
					{status == 'Absent' && <CancelIcon sx={iconSx} color="error" title="Absent (tap to toggle)" />}
				</IconButton>
				<StudentName student={student} />
			</Stack>
			{false && attendance?.id && status == 'Absent' &&
				<InlineEditableField model={attendance} field="notes" mutator={useSave} slots={{ input: { multiline: true } }} />
			}
		</Box>
	);
}
